<aside class="esf-main-sidebar esf-main-sidebar--working-space -has-transition -is-open -extra-width">

  <div class="esf-main-sidebar__content" *ngIf="customerOverviewService.listOfModals.editCommunicationModalOpened">
    <h3 i18n='Communication data edit modal title@@customerOverviewComponent.modalTitle.editCommunicationData'>Edit communication data</h3>
    <form [formGroup]="updateCommunicationForm" (ngSubmit)="updateFormSubmit(updateCommunicationForm)" id="updateCommunicationForm">
      <div app-form-field-email-checker
           [selectedClub]="selectedClub"
           [control]="updateCommunicationForm.controls['email']"
           [isEdit]="true"
           (searchResultsEmpty)="isEmailValid = $event">
      </div>
      <div class="esf-form-item"
           *ngIf="!customer.equalAuthorizationAndEmail && !selectedClub.isDataFeedActive && customer.hasEmail && !selectedClub.tixxExternalSso">
        <button class="esf-button esf-button--simple"
                [disabled]="!customer.isEditable"
                *ngIf="!shopAuthorizationLoading"
                (click)="setShopAuthorization()">
          <svg class="esf-icon esf-button__icon" width="16" height="16">
            <use xlink:href="#esf-icon-unlocked-16"></use>
          </svg>
          <span class="esf-button__icon-text" i18n="@@clubOverview.button.setEmailAsShopAuthorization">Set email as shop authorization</span>
        </button>
        <app-spinner [(show)]="shopAuthorizationLoading" style="margin-top: 20px;"></app-spinner>

      </div>
      <div class="esf-form-group">
        <div app-form-field-text-generic
             class="esf-form-item--1-2"
             [optional]="true"
             [control]="updateCommunicationForm.get('phone')"
             [placeholder]="flTranslations.i18nTelephone"
             [label]="flTranslations.i18nTelephone">
        </div>
        <div app-form-field-text-generic
             class="esf-form-item--1-2"
             [optional]="true"
             [control]="updateCommunicationForm.get('mobile')"
             [placeholder]="flTranslations.i18nMobile"
             [label]="flTranslations.i18nMobile">
        </div>
      </div>
      <ng-container *ngIf="selectedClub.isCampaignActive && customer.hasEmail && campaignStatus.status !== 'bounced'">
        <div class="esf-form-group">
          <div app-form-field-select
               class="esf-form-item--1-2"
               [control]="updateCommunicationForm.get('subscriptionStatus')"
               [label]="flTranslations.i18nMarketingPermission"
               [array]="availableStatuses"
               [preselectedValue]="preselectedValue">
          </div>
          <div class="esf-form-item esf-form-item--1-2">
            <label i18n='Form label text@@general.formLabel.lastChangedOn' class="esf-form-item__label" for="subscriptionDatetime">Last changed on</label>
            <div *ngIf="customer.subscriptionDatetime" type="text" class="esf-form-item__field"
                 id="subscriptionDatetime">{{ customer.subscriptionDatetime | date:'dd.MM.yyy HH:mm' }}</div>
            <div *ngIf="!customer.subscriptionDatetime" type="text" class="esf-form-item__field"
                 i18n="Placeholder text@@general.formPlaceholder.noDate" id="subscriptionDatetime">No date
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="selectedClub.isCampaignActive && campaignStatus.status === 'bounced'">
        <p class="esf-paragraph">
          <small i18n='@@general.text.marketingPermissionNoChangeBounced'>
            Marketing Permission currently can't be changed until customer is released from Bounce Status in CleverReach
            on {{ customer.subscriptionDatetime | date:'dd.MM.yyy' }}
          </small>
        </p>
      </ng-container>
    </form>
  </div>
</aside>

<div class="esf-main-sidebar--working-space__actions -has-transition"
     [ngClass]="{'-is-open -extra-width': customerOverviewService.listOfModals.editCommunicationModalOpened}">
  <app-submit-row-buttons [isFieldValid]="isEmailValid && updateCommunicationForm.valid && customer.hasTixxId"
                          [form]="'updateCommunicationForm'"
                          [cancelButtonText]="buttonsTranslations.i18nBack"
                          [submitButtonText]="buttonsTranslations.i18nSubmit"
                          [spinnerName]="spinnerName"
                          (cancelButton)="customerOverviewService.toggleAllModal(false); isEmailValid = true;">
  </app-submit-row-buttons>
</div>

<div class="esf-hamburger esf-hamburger--working-space  -has-transition"
     (click)="customerOverviewService.toggleAllModal(false); isEmailValid = true;"
     [ngClass]="{'-is-open': customerOverviewService.listOfModals.editCommunicationModalOpened}">
  <span class="esf-hamburger__icon"></span>
</div>
